module.exports = __webpack_public_path__ + "static/media/gg_statusInfo_building.f4b83185.svg";